/**
 * Core data fetch: GET _data/{portfolio}/{org}/{ring}.
 */

import { getAuthHeaders, buildDataUrl, type DataQueryOptions } from './request';

export interface DataBackendResponse<T = unknown> {
  items?: T[];
  last_id?: string;
  [key: string]: unknown;
}

/**
 * Fetches a ring from the data backend. Pagination via options.lastkey and response.last_id.
 */
export async function fetchRing<T = unknown>(
  ring: string,
  options?: DataQueryOptions
): Promise<DataBackendResponse<T>> {
  const url = buildDataUrl(ring, options);
  const headers = await getAuthHeaders();
  const res = await fetch(url, { method: 'GET', headers });
  const data = (await res.json().catch(() => ({}))) as DataBackendResponse<T> & {
    error?: string;
    message?: string;
  };
  if (!res.ok) {
    throw new Error(
      (data?.error as string) || (data?.message as string) || `HTTP ${res.status}`
    );
  }
  return data as DataBackendResponse<T>;
}
